module.exports = __webpack_public_path__ + "img/map7_empty.72e0da6f.png";